import React from 'react'
import { Typography, Layout, Divider, Button } from 'antd'
import { AppCard } from '@/shared/components/ui'
import { ArrowLeftOutlined, SafetyOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography
const { Content } = Layout

const PrivacyPage: React.FC = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ padding: '24px' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* 返回按钮 */}
          <div style={{ marginBottom: '24px' }}>
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={handleGoBack}
              style={{ marginBottom: '16px' }}
            >
              返回
            </Button>
          </div>

          <AppCard
            borderless
            style={{
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}
          >
            {/* 标题 */}
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <SafetyOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
              <Title level={2} style={{ color: '#52c41a' }}>
                多智能体客服系统隐私政策
              </Title>
              <Text type="secondary">最后更新日期：2025年12月7日</Text>
            </div>

            <Divider />

            {/* 内容区域 */}
            <div style={{ lineHeight: '1.8' }}>
              <Paragraph>
                我们非常重视您的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。
              </Paragraph>

              <Title level={3}>1. 信息收集</Title>
              <Paragraph>
                1.1 注册信息：当您注册账户时，我们会收集您的用户名、邮箱地址、公司信息等。
              </Paragraph>
              <Paragraph>
                1.2 使用信息：我们会收集您使用本系统的相关数据，包括但不限于：登录记录、操作日志、对话记录等。
              </Paragraph>
              <Paragraph>
                1.3 设备信息：我们可能会收集设备信息，如IP地址、浏览器类型、操作系统等。
              </Paragraph>

              <Title level={3}>2. 信息使用</Title>
              <Paragraph>
                2.1 提供服务：使用您的信息来提供和改进本系统的服务。
              </Paragraph>
              <Paragraph>
                2.2 沟通联系：通过您提供的联系方式与您进行服务相关沟通。
              </Paragraph>
              <Paragraph>
                2.3 安全保障：检测和防范安全威胁、欺诈或其他恶意活动。
              </Paragraph>
              <Paragraph>
                2.4 数据分析：对使用数据进行分析，以改进产品功能和用户体验。
              </Paragraph>

              <Title level={3}>3. 信息共享</Title>
              <Paragraph>
                3.1 我们不会将您的个人信息出售给第三方。
              </Paragraph>
              <Paragraph>
                3.2 仅在以下情况下，我们可能会共享您的信息：
              </Paragraph>
              <Paragraph style={{ marginLeft: '24px' }}>
                a) 获得您的明确同意
                <br />
                b) 法律法规要求
                <br />
                c) 保护我们或他人的合法权益
                <br />
                d) 与服务提供商合作（仅限于提供服务所需）
              </Paragraph>

              <Title level={3}>4. 数据安全</Title>
              <Paragraph>
                4.1 我们采取合理的技术和管理措施保护您的个人信息安全。
              </Paragraph>
              <Paragraph>
                4.2 我们对敏感信息进行加密存储和传输。
              </Paragraph>
              <Paragraph>
                4.3 尽管我们尽力保护您的信息，但无法保证绝对安全。
              </Paragraph>

              <Title level={3}>5. 数据保留</Title>
              <Paragraph>
                5.1 我们仅在实现本政策所述目的所需的期限内保留您的个人信息。
              </Paragraph>
              <Paragraph>
                5.2 当您注销账户后，我们将按照规定删除或匿名化处理您的信息。
              </Paragraph>

              <Title level={3}>6. 您的权利</Title>
              <Paragraph>
                6.1 访问权：您可以访问我们持有的您的个人信息。
              </Paragraph>
              <Paragraph>
                6.2 更正权：您可以要求更正不准确或不完整的个人信息。
              </Paragraph>
              <Paragraph>
                6.3 删除权：在特定情况下，您可以要求删除您的个人信息。
              </Paragraph>
              <Paragraph>
                6.4 撤回同意：您可以随时撤回先前给予的同意。
              </Paragraph>

              <Title level={3}>7. Cookie与追踪技术</Title>
              <Paragraph>
                7.1 我们使用Cookie和类似技术来提升用户体验。
              </Paragraph>
              <Paragraph>
                7.2 您可以通过浏览器设置管理Cookie偏好。
              </Paragraph>

              <Title level={3}>8. 未成年人保护</Title>
              <Paragraph>
                8.1 本系统不面向未成年人提供服务。
              </Paragraph>
              <Paragraph>
                8.2 如果我们发现收集了未成年人的个人信息，将立即删除。
              </Paragraph>

              <Title level={3}>9. 政策更新</Title>
              <Paragraph>
                9.1 我们可能会不时更新本隐私政策。
              </Paragraph>
              <Paragraph>
                9.2 更新后的政策将在系统中公布后生效。
              </Paragraph>

              <Title level={3}>10. 联系我们</Title>
              <Paragraph>
                如果您对本隐私政策有任何疑问，请通过以下方式联系我们：
              </Paragraph>

              <Divider />

              {/* 联系信息 */}
              <div style={{ textAlign: 'center', marginTop: '32px' }}>
                <Title level={4}>隐私保护负责人</Title>
                <Paragraph type="secondary">
                  邮箱：privacy@custom-service.com
                  <br />
                  电话：400-xxx-xxxx（转隐私保护部）
                  <br />
                  地址：XX省XX市XX区XX街道XX号
                </Paragraph>
                <Paragraph type="secondary" style={{ marginTop: '16px' }}>
                  我们承诺在15个工作日内回复您的隐私相关咨询。
                </Paragraph>
              </div>
            </div>
          </AppCard>

          {/* 底部信息 */}
          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <Text type="secondary">
              © 2025 多智能体客服系统 · 版本 1.0.0
            </Text>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default PrivacyPage